export const layoutStepsCreator = [
    {
        target: "#start-verification-btn",
        content: "Click here to begin your creator profile verification process.",
        disableBeacon: true,
        hideNext: true,
        hideBack: false,
        hideFinish: true,
    },
];

export const layoutStepsBrand = [
    {
        target: "#start-verification-btn",
        content: "Click here to begin your brand profile verification process.",
        disableBeacon: true,
        hideNext: true,
        hideBack: false,
        hideFinish: true
    },
];

// Bước mở modal - gọi hướng dẫn
export const creatorProfileInitialStep = [
    {
        target: "#verify-via-dm-btn",
        content: "Open the verification guide via DM.",
        disableBeacon: true,
        hideNext: true,
        hideBack: false,
        hideFinish: true,
    },
];

// Các bước sau khi modal mở (trong modal)
export const creatorVerifyStepsAfterModal = [
    {
        target: "#generate-code-btn",
        content: "Step 1: Click to generate your verification code.",
        disableBeacon: true,
        // hideBack: true,
    },
    {
        target: "#copy-code-btn",
        content: "Step 2: Copy the generated code.",
        disableBeacon: true,
        // hideBack: true,
    },
    {
        target: "#send-code-btn",
        content: "Step 3: Send the code to @vitrineverify via DM.",
        disableBeacon: true,
        // hideBack: true,
    },
    {
        target: "#reload-page-btn",
        content: "Step 4: After verification, reload the page.",
        disableBeacon: true,
        // hideBack: true,
        hideFinish: true,
    },
];

export const layoutStepsCreatorManuallyUpdateInstagramDataAfterVerifyDM = [
    {
        target: "#instagram-info-box", // 3. Hiển thị thông tin Instagram hiện tại
        content: "Here is your current Instagram data. Some fields may still be missing.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        // target: "#manually-update-instagram-button", // 4. Nút Manually Update
        target: "#btn-open-update-manual-modal",
        content: "Click here to manually update your Instagram information.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
     {
        // target: "#manually-update-instagram-button", // 4. Nút Manually Update
        target: "#btn-open-update-manual-modal-2",
        content: "Click here to manually update your Instagram information.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#next-after-via-dm-btn",
        content: "Click 'Next' to proceed to upload your profile image. This will help personalize your profile and let others recognize you easily.",
        disableBeacon: true,
        hideNext: true,
        hideBack: false,
        hideFinish: true,
    },
]

export const creatorProfileInitialStepAfterVerifyDM = [
    {
        target: "#next-after-via-dm-btn",
        content: "Click 'Next' to proceed to upload your profile image. This will help personalize your profile and let others recognize you easily.",
        disableBeacon: true,
        hideNext: true,
        hideBack: false,
        hideFinish: true,
    },
];

export const creatorProfileStepUploadImage = [
    {
        target: "#upload-profile-image-btn", // selector của nút hoặc vùng upload
        content: "Upload your profile image here to complete your creator profile.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#next-after-upload-profile-image-btn", // selector của nút next
        content: "Click 'Next' to proceed to the step where you can add a link or upload your portfolio.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
];

export const creatorProfileInitialStepAfterUploadImage = [
    {
        target: "#next-after-upload-profile-image-btn", // selector của nút next
        content: "Click 'Next' to proceed to the step where you can add a link or upload your portfolio.",
        disableBeacon: true,
        hideNext: false,
        hideBack: true,
        hideFinish: true,
    },
];

export const creatorProfileStepAddPortfolio = [
    {
        target: "#portfolio-url-input", // selector cho ô nhập URL
        content: "You can add a link to your portfolio here. Or skip to upload files below.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#portfolio-upload-area", // selector cho khu vực kéo/thả file
        content: "Drag and drop your attachments here to upload them as part of your portfolio.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#next-after-upload-portfolio-btn", // selector cho nút Next
        content: "Click 'Next' to proceed to the 'Add your past experiences' step.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
];

export const creatorProfileStepAddExperience = [
    {
        target: "#experience-date-from", // ô chọn ngày bắt đầu
        content: "Select the start date of your experience with the brand.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#experience-date-to", // ô chọn ngày kết thúc
        content: "Select the end date of your experience with the brand.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#experience-brand-name", // ô nhập tên thương hiệu
        content: "Enter the name of the brand you've worked with.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#experience-description", // ô mô tả công việc
        content: "Briefly describe your experience working with the brand.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#experience-add-button", // nút để thêm kinh nghiệm mới (nếu có)
        content: "You can add this experience and more if needed.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#next-after-add-experience-btn", // nút Next tới bước tiếp theo
        content: "Click 'Next' to continue to the 'Add more info that is required' step.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
];

export const creatorProfileStepAddMoreInfoRequired = [
    {
        target: "#active-hours-start",
        content: "Enter the start time of your active hours.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#active-hours-end",
        content: "Enter the end time of your active hours.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#active-days-selector",
        content: "Select the days of the week you're active.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#niche-input",
        content: "Add your niche(s). If you have more than one, separate them with commas.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#sponsor-input", // 👈 Thêm id cho ô input sponsor
        content: "Do you have any active sponsors? If yes, please mention them below.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#finish-profile-btn",
        content: "Click here to finish completing your profile.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
];

// --------


export const layoutStepsCreatorManuallyUpdateInstagramData = [
    {
        target: "#avatar-button", // 1. Click avatar
        content: "To complete your profile, you'll need to update your Instagram data. Start by clicking your avatar in the top corner to open the menu.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
];


export const layoutStepsCreatorManuallyUpdateInstagramDataAfterClickManuallyUpdateBtn = [
    // Khi popup hiển thị:
    {
        target: "#input-followers", // 5. Input Followers
        content: "Enter your number of followers.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#input-following", // 6. Input Following
        content: "Enter how many accounts you’re following.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#input-posts", // 7. Input Posts
        content: "Enter your total number of posts.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#input-impressions", // 8. Input Impressions
        content: "Enter your Instagram impressions.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#input-niche", // 9. Input Niche
        content: "Add your niche(s). Separate multiple niches with commas.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#input-reach", // 10. Input Reach
        content: "Enter your Instagram reach.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#input-website", // 11. Input Website
        content: "Enter the link to your website (optional).",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#upload-profile-picture", // 12. Upload Instagram profile picture
        content: "Upload your Instagram profile picture.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#upload-instagram-screenshot", // 13. Upload Instagram screenshot
        content: "Upload a screenshot of your Instagram account.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
    {
        target: "#submit-instagram-manual-data", // 14. Submit
        content: "Click Submit to send your data for approval. You’ll be notified via email once it's reviewed.",
        disableBeacon: true,
        hideNext: false,
        hideBack: false,
        hideFinish: true,
    },
];